var map = {
	"./ca": 331,
	"./ca.json": 331,
	"./de": 332,
	"./de.json": 332,
	"./es": 333,
	"./es.json": 333,
	"./whitelist_ca": 334,
	"./whitelist_ca.json": 334,
	"./whitelist_de": 335,
	"./whitelist_de.json": 335,
	"./whitelist_es": 336,
	"./whitelist_es.json": 336
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;


//////////////////
// WEBPACK FOOTER
// ./src/static/locales ^\.\/.*$
// module id = 457
// module chunks = 0